import axios from 'axios';
import { getUserData } from './storageService';

const API_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/commission-config`
  : 'https://backend-c-0mxm.onrender.com/api/commission-config';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const user = getUserData();
  if (user) {
    config.headers.Authorization = `Bearer ${user.userId || user.token}`;
  }
  return config;
});

const handleError = (error) => {
  if (error.response) {
    return { message: error.response.data.message || 'Có lỗi xảy ra', status: error.response.status };
  }
  if (error.request) {
    return { message: 'Không thể kết nối đến server', status: 0 };
  }
  return { message: 'Có lỗi xảy ra', status: 0 };
};

export const getMyCommissionConfig = async () => {
  try {
    const response = await api.get('/my');
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const getCommissionConfig = async (userId) => {
  try {
    const response = await api.get(`/${userId}`);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const getAllCommissionConfigs = async () => {
  try {
    const response = await api.get('/all');
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const updateCommissionConfig = async (userId, configData) => {
  try {
    const response = await api.put(`/${userId}`, configData);
    return { success: true, data: response.data.data, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const deleteCommissionConfig = async (userId) => {
  try {
    const response = await api.delete(`/${userId}`);
    return { success: true, message: response.data.message };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};

export const previewCommission = async (userId, previewData) => {
  try {
    const response = await api.post(`/${userId}/preview`, previewData);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, error: handleError(error) };
  }
};
